<template>
    <v-chart :options="option"/>
</template>

<script>
    import ECharts from 'vue-echarts'
    import 'echarts/lib/chart/line'

    export default {
        name: "InviteECharts",
        components: {
            'v-chart': ECharts,
        },
        props: {
            pieData: Array
        },
        watch: {
            pieData: function (newVal, oldVal) {
                this.option.series[0].data = newVal
            }
        },
        data() {
            return {
                option: {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b} : {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        left: '10%',
                        data: ['非邀请新增', '邀请新增']
                    },
                    series: [
                        {
                            name: '新增类型',
                            type: 'pie',
                            radius: '65%',
                            center: ['55%', '60%'],
                            legend: {},
                            label: {
                                position: 'inner',
                                formatter: '{d}%'
                            },
                            data: [],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                },

            }
        },
    }
</script>

<style scoped>
    .echarts {
        width: 100%;
        height: 100%;
    }
</style>